export enum DrinkType {
  Beer = 'Beer',
  Wine = 'Wine',
  Cocktails = 'Cocktails',
  Beverages = 'Beverages'
}
